module.exports = __webpack_public_path__ + "static/media/image_home.9cf01899.png";